import { render } from "./CreateProjects.vue?vue&type=template&id=43b0a356"
import script from "./CreateProjects.vue?vue&type=script&lang=js"
export * from "./CreateProjects.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__